import React from 'react';
import PropTypes from 'prop-types';
import logo from './../img_icons/logo.svg';
import { Box, AppBar, Toolbar, Button, Container, Divider, Typography, MenuItem, Drawer } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';

const logoStyle = {
  width: '50px',
  height: '50px',
  cursor: 'pointer',
  borderRadius: '50%',
  border: '1.5px solid #f1f1f1', // Añade esta línea
};

const Header = ({ mode, toggleColorMode }) => {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleInitWeb = () => {
    navigate('/');
  };

  const handleServiceWeb = () => {
    navigate('/services-page-web');
  };

  const handleVisionWeb = () => {
    navigate('/vision-page-web');
  };

  const handleImplementacionesWeb = () => {
    navigate('/program-page-web');
  };

  const handleBlogWeb = () => {
    navigate('/blog-page-web');
  };

  const handleContactanosWeb = () => {
    navigate('/contactanos-page-web');
  };

  const handleCertificadosWeb = () => {
    navigate('/certificados-page-web');
  }

  const handleLoginWeb = () => {
    navigate('/login');
  }

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  return (
    <div>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: 'transparent',
          backgroundImage: 'none',
          mt: 2,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              borderRadius: '999px',
              maxHeight: 40,
            })}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                px: 0,
                position: 'relative',
                justifyContent: 'center',
                gap: 0.5,
              }}
            >
              <img
                src={logo}
                style={logoStyle}
                alt="logo of calocho"
                onClick={handleInitWeb}
              />
              <Box sx={{
                  display: { xs: 'none', md: 'flex' }, 
                  alignItems: 'center', 
                  textAlign: 'center' ,
                  justifyContent: 'center',
                }}>
                <MenuItem
                  onClick={handleServiceWeb}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="#fffff0" sx={{         
                    textShadow: `
                      1px 1px 2px rgba(0, 0, 0, 0.3), 
                      -1px -1px 2px rgba(0, 0, 0, 0.3),
                      1px -1px 2px rgba(0, 0, 0, 0.3),
                      -1px 1px 2px rgba(0, 0, 0, 0.3)
                    `,
                    background: 'linear-gradient(90deg, transparent 0%, #000000 50%, transparent 80%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                  }}>
                    Mis servicios
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={handleVisionWeb}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2"  color="#fffff0" sx={{         
                    textShadow: `
                      1px 1px 2px rgba(0, 0, 0, 0.3), 
                      -1px -1px 2px rgba(0, 0, 0, 0.3),
                      1px -1px 2px rgba(0, 0, 0, 0.3),
                      -1px 1px 2px rgba(0, 0, 0, 0.3)
                    `,
                    background: 'linear-gradient(90deg, transparent 0%, #000000 50%, transparent 80%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                  }}>
                    Visión
                  </Typography>
                </MenuItem>


                <MenuItem
                  onClick={handleCertificadosWeb}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="#fffff0" sx={{         
                    textShadow: `
                      1px 1px 2px rgba(0, 0, 0, 0.3), 
                      -1px -1px 2px rgba(0, 0, 0, 0.3),
                      1px -1px 2px rgba(0, 0, 0, 0.3),
                      -1px 1px 2px rgba(0, 0, 0, 0.3)
                    `,
                    background: 'linear-gradient(90deg, transparent 0%, #000000 50%, transparent 80%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                  }}>
                    Certificados
                  </Typography>
                </MenuItem>

                <MenuItem
                  onClick={handleImplementacionesWeb}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="#fffff0" sx={{         
                    textShadow: `
                      1px 1px 2px rgba(0, 0, 0, 0.3), 
                      -1px -1px 2px rgba(0, 0, 0, 0.3),
                      1px -1px 2px rgba(0, 0, 0, 0.3),
                      -1px 1px 2px rgba(0, 0, 0, 0.3)
                    `,
                    background: 'linear-gradient(90deg, transparent 0%, #000000 50%, transparent 80%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                  }}>
                    Mi trabajo
                  </Typography>
                </MenuItem>


                <MenuItem
                  onClick={handleBlogWeb}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="#fffff0" sx={{         
                    textShadow: `
                      1px 1px 2px rgba(0, 0, 0, 0.3), 
                      -1px -1px 2px rgba(0, 0, 0, 0.3),
                      1px -1px 2px rgba(0, 0, 0, 0.3),
                      -1px 1px 2px rgba(0, 0, 0, 0.3)
                    `,
                    background: 'linear-gradient(90deg, transparent 0%, #000000 50%, transparent 80%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                  }}>
                    Blog
                  </Typography>
                </MenuItem>
                <MenuItem
                  onClick={handleContactanosWeb}
                  sx={{ py: '6px', px: '12px' }}
                >
                  <Typography variant="body2" color="#fffff0" sx={{         
                    textShadow: `
                      1px 1px 2px rgba(0, 0, 0, 0.3), 
                      -1px -1px 2px rgba(0, 0, 0, 0.3),
                      1px -1px 2px rgba(0, 0, 0, 0.3),
                      -1px 1px 2px rgba(0, 0, 0, 0.3)
                    `,
                    background: 'linear-gradient(90deg, transparent 0%, #000000 50%, transparent 80%)',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                  }}>
                    Contacto
                  </Typography>
                </MenuItem>
              </Box>
            </Box>
            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
              }}
            >
              {/*<ToggleColorMode mode={mode} toggleColorMode={toggleColorMode} />*/}
              <Button
                variant="outlined"
                color="primary"
                size="small"
                component="a"
                onClick={handleLoginWeb}
                target="_blank"
                sx={{
                  border: 'solid #8E0505 2px',
                  color: '#fff',
                  ':hover': {
                    backgroundColor: '#5d0303',
                  },
                }}
              >
                Iniciar sesión
              </Button>
              {/*<Button
                color="primary"  
                variant="contained"
                size="small"
                component="a"
                href="/material-ui/getting-started/templates/sign-up/"
                target="_blank"
              >
                Sign up
            </Button>*/}
            </Box>
            <Box sx={{ display: { sm: '', md: 'none' } }}>
              <Button
                variant="text"
                color="#8E0505"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ minWidth: '30px', p: '4px' }}
              >
                <MenuIcon />
              </Button>
              <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                  sx={{
                    minWidth: '60dvw',
                    p: 2,
                    backgroundColor: '8E0505',
                    flexGrow: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'end',
                      flexGrow: 1,
                    }}
                  >
                    {/*<ToggleColorMode mode={mode} toggleColorMode={toggleColorMode} />*/}
                  </Box>
                  <MenuItem onClick={handleInitWeb}>
                    Inicio
                  </MenuItem>
                  <MenuItem onClick={handleServiceWeb}>
                    Mis servicios
                  </MenuItem>
                  <MenuItem onClick={handleVisionWeb}>
                    Visión
                  </MenuItem>
                  <MenuItem onClick={handleCertificadosWeb}>
                    Certificados
                  </MenuItem>
                  <MenuItem onClick={handleImplementacionesWeb}>
                    Mi trabajo
                  </MenuItem>
                  <MenuItem onClick={handleBlogWeb}>
                    Blog
                  </MenuItem>
                  <MenuItem onClick={handleContactanosWeb}>Contacto</MenuItem>
                  <Divider />
                  {/*<MenuItem>
                    <Button
                      color="primary"
                      variant="contained"
                      component="a"
                      href="/material-ui/getting-started/templates/sign-up/"
                      target="_blank"
                      sx={{ width: '100%' }}
                    >
                      Sign up
                    </Button>
                  </MenuItem>*/}
                  <MenuItem>
                    <Button
                      color="primary"
                      variant="outlined"
                      onClick={handleLoginWeb}
                      sx={{
                        border: 'solid #8E0505 2px',
                        color: '#8E0505',
                        ':hover': {
                          backgroundColor: '#5d0303',
                        },
                      }}
                    >
                      Iniciar sesión
                    </Button>
                  </MenuItem>
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

Header.propTypes = {
  mode: PropTypes.oneOf(['dark', 'light']).isRequired,
  toggleColorMode: PropTypes.func.isRequired,
};

export default Header;